import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { AppLayout } from 'modules/core/layouts'
import login from 'modules/login'
import PropTypes from 'prop-types'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import UploadS3File from 'modules/uploadS3/containers/UploadS3File/UploadS3File'
import { Home } from 'modules/home/containers'

const PrivateRoute = ({ loggedUser, isAuthenticated, logout, component: Component, ...rest }) => {
  const enableOldS3 = useFeatureIsOn('enalbe-old-s3')

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          if (rest.path === '/login') {
            return <Redirect to="/" />
          }
          if (rest.path === '/' && loggedUser.isSuperuser) {
            return <Redirect to="/empresas" />
          } else if (rest.path === '/' && loggedUser.link_upload_file) {
            const HomeComponent = enableOldS3 ? UploadS3File : Home

            return (
              <AppLayout loggedUser={loggedUser} onLogout={logout}>
                <HomeComponent />
              </AppLayout>
            )
          } else {
            return (
              <AppLayout loggedUser={loggedUser} onLogout={logout}>
                <Component {...props} />
              </AppLayout>
            )
          }
        } else {
          if (
            rest.path === '/login' ||
            rest.path === '/restablecercontrasenia' ||
            rest.path === '/politicayterminos'
          ) {
            return <Component {...props} />
          }

          return <Redirect to="/login" />
        }
      }}
    />
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
  isAuthenticated: login.selectors.getIsAuthenticated(state),
})

const mapDispatchToProps = {
  onLogout: login.actions.onLogout,
  logout: login.actions.logout,
}

PrivateRoute.propTypes = {
  loggedUser: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  onLogout: PropTypes.func,
  component: PropTypes.any,
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)
